/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit State/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function State({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/AddressInput/State",
  onChange
  
}) {
let questionAnswerStateValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer.state',
})
let questionAnswerStateChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer.state',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 marginTop={dtSpaceS}
 width={250}
 flexGrow={0}
 data="question.answer.state"
 value={questionAnswerStateValueData}
 onChange={questionAnswerStateChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="State"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}